export default __webpack_public_path__ + "static/media/Endress+Hauser.d3d81b5b.png";